export function assertUnreachable(_x: never) {}

// Typescript doesn't correctly type `key in obj` inline
export function hasKey<O extends object>(
  obj: O,
  key: PropertyKey,
): key is keyof O {
  return key in obj;
}

export function hasOwnKey<T extends Record<string, any>, K extends keyof T>(
  messages: T,
  key: any,
): key is K {
  return messages.hasOwnProperty(key);
}

export type Unpacked<T> = T extends ReadonlyArray<infer U> ? U : T;
